import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Notes: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px] stroke-[1.6px]', className)}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83333 3.16668C5.56812 3.16668 5.31376 3.27203 5.12623 3.45957C4.93869 3.64711 4.83333 3.90146 4.83333 4.16668V15.8333C4.83333 16.0986 4.93869 16.3529 5.12623 16.5404C5.31376 16.728 5.56812 16.8333 5.83333 16.8333H14.1667C14.4319 16.8333 14.6862 16.728 14.8738 16.5404C15.0613 16.3529 15.1667 16.0986 15.1667 15.8333V4.16668C15.1667 3.90146 15.0613 3.64711 14.8738 3.45957C14.6862 3.27203 14.4319 3.16668 14.1667 3.16668H5.83333ZM4.18342 2.51676C4.621 2.07918 5.21449 1.83334 5.83333 1.83334H14.1667C14.7855 1.83334 15.379 2.07918 15.8166 2.51676C16.2542 2.95435 16.5 3.54784 16.5 4.16668V15.8333C16.5 16.4522 16.2542 17.0457 15.8166 17.4833C15.379 17.9208 14.7855 18.1667 14.1667 18.1667H5.83333C5.21449 18.1667 4.621 17.9208 4.18342 17.4833C3.74583 17.0457 3.5 16.4522 3.5 15.8333V4.16668C3.5 3.54784 3.74583 2.95435 4.18342 2.51676ZM6.83333 5.83334C6.83333 5.46515 7.13181 5.16668 7.5 5.16668H12.5C12.8682 5.16668 13.1667 5.46515 13.1667 5.83334C13.1667 6.20153 12.8682 6.50001 12.5 6.50001H7.5C7.13181 6.50001 6.83333 6.20153 6.83333 5.83334ZM6.83333 9.16668C6.83333 8.79849 7.13181 8.50001 7.5 8.50001H12.5C12.8682 8.50001 13.1667 8.79849 13.1667 9.16668C13.1667 9.53487 12.8682 9.83334 12.5 9.83334H7.5C7.13181 9.83334 6.83333 9.53487 6.83333 9.16668ZM6.83333 12.5C6.83333 12.1318 7.13181 11.8333 7.5 11.8333H10.8333C11.2015 11.8333 11.5 12.1318 11.5 12.5C11.5 12.8682 11.2015 13.1667 10.8333 13.1667H7.5C7.13181 13.1667 6.83333 12.8682 6.83333 12.5Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default Notes;
